import { useMutation } from 'react-query';
import axios from 'axios';
import { CategoriesTopicsTableAPI } from '../../../constants/API';
import { multipartHeaders } from '../../../constants/HeadersAPI';
import { QueueItemIconMedia } from '../../../types/Admin/ItemIconTypes';

export const useUploadTopicIcon = (topicId?: number | null) => {
  const { mutateAsync: uploadTopicIcon, isLoading: isUploadTopicIconLoading } = useMutation(
    async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);
      const url = topicId
        ? CategoriesTopicsTableAPI.uploadTopicIcon(topicId)
        : CategoriesTopicsTableAPI.uploadPendingTopicIcon;
      const response = await axios.post<QueueItemIconMedia>(url, formData, multipartHeaders());
      return response.data.url;
    }
  );

  return { uploadTopicIcon, isUploadTopicIconLoading };
};
